export default "__VITE_ASSET__CrVkgGU7__"